export default __webpack_public_path__ + "static/media/girls-studying.f5b779f6.png";